module.exports = __webpack_public_path__ + "static/media/print_02_A.cd1ffd22.png";